<template>
  <v-select :value="booking_type" v-bind:items="bookingTypes" item-value="value" item-text="text" :label="label"
    multiple prepend-icon="mdi-filter-outline" :clearable="isClearable" @change="updateData" dense hide-details>
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon :color="booking_type.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Select All</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip small v-if="index >= 0 && index < visibleChips">
        <span>{{ item.text }}</span>
      </v-chip>
      <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ booking_type.length - visibleChips
        }})</span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    booking_type: {
      type: Array,
      default: function () { return []; },
    },
    label: String,
    field: {
      default: 'booking_type',
      required: true,
    },
    isClearable: {
      type: Boolean,
      default: true
    },
    visibleChips: {
      type: Number,
      default: 3
    },
  },
  computed: {
    icon: function () {
      if (this.selectAll) return 'mdi-close-box'
      if (this.selectSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectAll: function () {
      return this.booking_type.length === this.bookingTypes.length;
    },
    selectSome: function () {
      return this.booking_type.length > 0 && !this.selectAll;
    },
  },
  data() {
    return {
      bookingTypes: [
        { text: 'Completed', value: 'completed' },
        { text: 'Ongoing', value: 'ongoing' },
        { text: 'Upcoming', value: 'upcoming' }
      ],
      selectedTypes: [],
    }
  },
  created() {
    this.setInitialSelection();
  },
  methods: {
    updateData(v) {
      this.$emit('updateData', { "field": this.field, "value": v === null ? [] : v })
    },
    setInitialSelection() {
      this.selectedTypes = this.bookingTypes.slice().map(element => element.value);
      this.updateData(this.selectedTypes);
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAll) {
          this.selectedTypes = [];
        } else {
          this.selectedTypes = this.bookingTypes.slice().map(element => element.value);
        }
        this.updateData(this.selectedTypes);
      })
    },
  }
}
</script>
